import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import FormControl from "@mui/material/FormControl";
import { useFormik } from "formik";
import InputField from "../../../common/CustomInputField";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "30%",
  bgcolor: "background.paper",
  minWidth: "350px !important",

  background: "color.white",
  boxShadow:
    "  0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)",
  padding: "0px 0 10px 0",
  display: "flex",
  flexDirection: "column",
};

const BasicModal = (props) => {
  const {
    open,
    handleClose,
    newAccountFlag,
    focusedFeild,
    accountTypeId,
    addSubOwnersData,
    selectedSubOwner = {},
    selectedSubOwnerIndex,
    addNewAccount,
  } = props;
  const { t } = useTranslation();
  const { accountName, accountNumber } = focusedFeild;
  const initialValues =
    Object.keys(selectedSubOwner).length > 0
      ? {
          ...selectedSubOwner,
          dateOfValue: selectedSubOwner?.dateOfValue.slice(0, 10) || "",
        }
      : {
          accountName: accountName ? accountName : "",
          accountNumber: accountNumber ? accountNumber : "",
          nameOfOwner: "",
          ownerShipPercentage: "",
          accountBalance: "",
          dateOfValue: "",
        };

  const validate = Yup.object({
    accountName: Yup.string()
      .required(t("required"))
      .max(30, t("max-30-characters")),
    accountNumber: Yup.string().max(30, t("max-30-characters")),
    nameOfOwner: Yup.string()
      .required(t("required"))
      .max(50, t("max-50-characters")),
    ownerShipPercentage: Yup.number()
      .required(t("required"))
      .min(0, t("between-0-100"))
      .max(100, t("between-0-100")),
    accountBalance: Yup.number()
      .required(t("required"))
      .min(0, t("must-be-positive"))
      .max(9999999999, t("max-10-digits")),
    // dateOfValue: Yup.string()
    //   .test("DATE", t("between-1950-2050"), (value) => {
    //     if (value) {
    //       let [yyyy, mm, dd] = value?.split("-");
    //       return 1950 <= yyyy && yyyy <= 2050;
    //     }
    //   }),
 
    dateOfValue: Yup.string()
      .required(t("required"))
      .nullable()
      .test("DATE", t("choose-between-1930"), (value) => {
        if (value) {
          let [yyyy, mm, dd] = value?.split("-");
          let currentDate = new Date(Date.now()).toLocaleDateString("en-GB");
          let [curDay, curMonth, curYear] = currentDate.split("/");
          return 1930 <= yyyy && curYear >= yyyy;
        }
      }),
  });

  const onSubmit = async (values, onSubmitProps) => {
    const formattedDate =
    values.date instanceof dayjs
      ? values.date.format("YYYY-MM-DD")
      : values.date;
  const updatedValues = {
    ...values,
    date: formattedDate,
  };
    newAccountFlag
      ? addNewAccount(values)
      : addSubOwnersData(values, accountTypeId, selectedSubOwnerIndex);

    onSubmitProps.resetForm();
    handleClose();
  };
  const formik = useFormik({
    initialValues: initialValues,
    onSubmit: onSubmit,
    validationSchema: validate,
    enableReinitialze: true,
  });

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div>
          <Box sx={style}>
            <Box
              lg={12}
              sx={{
                backgroundColor: "color.magentaLight2",
                padding: "10px",
                color: "color.brown",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography id="modal-modal-title" pl={3} component="p">
                {accountName ? accountName : t("bank-balance")}
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Typography
                  onClick={() => handleClose()}
                  sx={{
                    cursor: "pointer",
                  }}
                  pr={1}
                  variant="h6"
                  component="h2"
                >
                  <img src="/assets/icons/close-icon.svg" alt="Close" />
                </Typography>
              </Box>
            </Box>
            <FormControl sx={{ width: "100%", padding: "20px " }}>
              {(newAccountFlag || selectedSubOwnerIndex === 0) && (
                <>
                  <InputField
                    label={t("name-for-account")}
                    value={formik.values.accountName}
                    onChange={formik.handleChange}
                    name="accountName"
                    placeholder={t("placeholder-2")}
                    error={
                      Boolean(
                        formik?.errors?.accountName &&
                          formik?.touched?.accountName
                      )
                        ? formik.errors
                        : null
                    }
                  />
                  <InputField
                    label={t("input-19")}
                    value={formik.values.accountNumber}
                    onChange={formik.handleChange}
                    name="accountNumber"
                    placeholder={t("placeholder-3")}
                    error={
                      Boolean(
                        formik?.errors?.accountNumber &&
                          formik?.touched?.accountNumber
                      )
                        ? formik.errors
                        : null
                    }
                  />
                </>
              )}
              <InputField
                label={t("common-table-heading-1")}
                value={formik.values.nameOfOwner}
                onChange={formik.handleChange}
                name="nameOfOwner"
                placeholder={t("placeholder-1")}
                error={
                  Boolean(
                    formik?.errors?.nameOfOwner && formik?.touched?.nameOfOwner
                  )
                    ? formik.errors
                    : null
                }
                maxlength={50}
              />

              <InputField
                type="number"
                label={t("common-table-heading-2")}
                value={formik.values.ownerShipPercentage}
                onChange={formik.handleChange}
                name="ownerShipPercentage"
                placeholder="00"
                error={
                  Boolean(
                    formik?.errors?.ownerShipPercentage &&
                      formik?.touched?.ownerShipPercentage
                  )
                    ? formik.errors
                    : null
                }
              />

              <InputField
                type="format-number"
                label={t("bb-table-heading-2")}
                value={
                  formik.values.accountBalance
                    ? formik.values.accountBalance
                    : ""
                }
                onChange={(value) => {
                  formik.setFieldValue("accountBalance", value);
                }}
                // value={formik.values.accountBalance}
                // onChange={formik.handleChange}
                name="accountBalance"
                placeholder={t("placeholder-4")}
                error={
                  Boolean(
                    formik?.errors?.accountBalance &&
                      formik?.touched?.accountBalance
                  )
                    ? formik.errors
                    : null
                }
              />
              <InputField
                type="date"
                label={t("common-table-heading-3")}
                // value={formik.values.dateOfValue}
                value={formik.values.dateOfValue ? dayjs(formik.values.dateOfValue).toDate() : null}

                // onChange={(newValue) => {
                //     formik.setFieldValue("dateOfValue", newValue); 
                //   }}
                onChange={(value) => {
                  formik.setFieldValue("dateOfValue", value ? dayjs(value).format("YYYY-MM-DD") : null);
                }}
                name="dateOfValue"
                onFocus={(e) => (e.target.type = "date")}
              
                error={
                  Boolean(
                    formik?.errors?.dateOfValue && formik?.touched?.dateOfValue
                  )
                    ? formik.errors
                    : null
                }
              />
            </FormControl>
            <Button
              sx={{
                color: "color.brown",
                padding: "8px 50px",
                backgroundColor: "color.magentaLight2",
                margin: "2rem auto 0 auto",
                fontWeight: "bold",
                borderRadius: "15px",
                textTransform: "initial",
                textTransform: "initial",
                "&:hover": {
                  backgroundColor: "color.magentaLight1",
                  boxShadow: "none",
                },
              }}
              onClick={() => formik.handleSubmit()}
            >
              {t("save")}
            </Button>
          </Box>
        </div>
      </Modal>
    </div>
  );
};

export default BasicModal;
